import React, { useEffect, useState, useRef } from 'react';
import { Card } from './ui/Card';
// Updated Bonus Items with new images and structure
const BONUS_ITEMS = [{
  img: 'https://cdn.magicpatterns.com/uploads/3GxNW2mqLeLQQM8uXogwKs/1-bono-1-masterclass-electricidad-y-sist_pSXtUiEbQXWmz3ZKkWJnMg_xt42s8eGT4y5T4d745wQEQ_hd.png',
  title: 'Masterclass: Electricidad',
  desc: 'Dominá la parte eléctrica.',
  price: '$14.990'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/gBZrJYF9LpBTPSr8LKGLhC/a-photorealistic-product-photograph-base_KJExYIC7T7ezSQAcBnxoCA_KpTGN4p-TgiDTGFU-s-_KA_hd.png',
  title: 'Inyección Electrónica',
  desc: 'Diagnóstico moderno.',
  price: '$14.990'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/euZfgHHSv11mZWzgZtqN7Z/3-bono-3-ingenieria-en-frio-refrigeracio_cmPLItUmTsK4VNRw71s3JA_wkrRncOAT5KUmW_FZLFrNg_hd.png',
  title: 'Ingeniería en Frío',
  desc: 'Refrigeración avanzada.',
  price: '$14.990'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/3gWF1MSNvT8B6e2LYafAUJ/4-bono-4-manual-del-diagnosticador-resol_S0yjOwPgQ6WNJEZVQbOJtg_8wJE_mldThWxidPeF8yaSQ_hd.png',
  title: 'Manual Diagnóstico',
  desc: 'Fallas críticas.',
  price: '$14.990'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/qu8Xpx1LqNGAfuHyoL4peB/5-bono-5-la-boveda-tecnica-pack-definiti_mqr16J_lQfeHLGCqJ3h-sw_TBqObNOsR_u8yHWymQAgGw_hd.png',
  title: 'Bóveda Técnica',
  desc: 'Diagramas y planos.',
  price: '$14.990'
}];
export function BonusCarousel() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const handleScroll = () => {
      const maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll > 0) {
        setScrollProgress(el.scrollLeft / maxScroll);
      }
    };
    el.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full relative group" data-id="element-2">
      {/* Scrollable Container - Fluid horizontal scroll showing 1.5 cards on mobile */}
      <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory gap-4 pb-6 px-4 md:px-0 scrollbar-hide" style={{
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }} data-id="element-3">
        {BONUS_ITEMS.map((bonus, idx) => <div key={idx} className="snap-center shrink-0 w-[60vw] md:w-[280px]" data-id="element-4">
            {/* Strictly Vertical and Compact Card */}
            <Card className="h-full flex flex-col overflow-hidden border-slate-700 bg-slate-900/80 backdrop-blur-sm shadow-xl rounded-xl" data-id="element-5">
              {/* Image Area - 50% height */}
              <div className="h-[200px] w-full relative overflow-hidden bg-slate-950" data-id="element-6">
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover" data-id="element-7" />
                {/* Badge Top Right */}
                <div className="absolute top-2 right-2 bg-green-500 text-black text-[10px] font-black px-2 py-0.5 rounded shadow-md" data-id="element-8">
                  GRATIS
                </div>
              </div>

              {/* Content Area */}
              <div className="flex-1 p-3 flex flex-col justify-between bg-slate-900" data-id="element-9">
                <div data-id="element-10">
                  <h3 className="font-bold text-white text-base leading-tight mb-1" data-id="element-11">
                    {bonus.title}
                  </h3>
                  <p className="text-slate-400 text-xs leading-tight truncate" data-id="element-12">
                    {bonus.desc}
                  </p>
                </div>

                {/* Price Row */}
                <div className="mt-3 pt-2 border-t border-slate-800 flex items-center justify-between" data-id="element-13">
                  <span className="text-slate-500 text-xs line-through decoration-red-500 decoration-2 font-bold" data-id="element-14">
                    {bonus.price}
                  </span>
                  <span className="text-[#39FF14] font-black text-xs tracking-wide drop-shadow-[0_0_5px_rgba(57,255,20,0.5)]" data-id="element-15">
                    BONIFICADO
                  </span>
                </div>
              </div>
            </Card>
          </div>)}
      </div>

      {/* Progress Bar */}
      <div className="mx-4 md:mx-0 mt-2 h-1 bg-slate-800 rounded-full overflow-hidden max-w-md mx-auto" data-id="element-16">
        <div className="h-full bg-gradient-to-r from-orange-500 to-yellow-500 rounded-full transition-all duration-150" style={{
        width: `${Math.max(20, scrollProgress * 100)}%`
      }} data-id="element-17" />
      </div>

      {/* Swipe Text */}
      <p className="text-center text-slate-500 text-xs mt-2 animate-pulse" data-id="element-18">
        👉 Desliza para ver todos los regalos 👈
      </p>
    </div>;
}